import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Form,
  Button
} from 'semantic-ui-react'

export default class FileItem extends React.Component {
  constructor (props) {
    super(props)
    this._fileInput = null
  }
  /*
  componentDidUpdate (prevProps, prevState) {
    if (this.props.openFileDialog === true && prevProps.openFileDialog !== true) {
      if (this._fileInput) {
        this._fileInput.click()
      }
    }
  }
  */
  onAction (e) {
    e.preventDefault()
    e.stopPropagation()
    if (this._fileInput) {
      this._fileInput.click()
    }
  }

  onFileChange (e) {
    e.preventDefault()
    const files = []
    // e.target.files is a FileList object, need to convert
    // to array
    for (let i = 0; i < e.target.files.length; i++) {
      files.push(e.target.files.item(i))
    }
    if (files.length) {
      this.props.onAction(this.props.actionType, {files})
    }
    // reset the file <input> value or else we can't
    // upload the same file twice. Normally, we wouldn't want to do that
    // but a user could upload the file, delete it, then upload it again
    this._fileInput.value = ''
  }

  render () {
    return (
      <Form.Field width={R.isNil(this.props.width) ? null : this.props.width}>
        <Button
          // style={style}
          onMouseDown={ this.onAction.bind(this) }
          tabIndex="-1"
          title={this.props.tooltip}>
          { this.props.label }
          <input type="file"
            onChange={ this.onFileChange.bind(this)}
            style={ {display: 'none', visibility: 'hidden'}}
            ref={c => { this._fileInput = c }}
            accept={ this.props.accept }
            multiple
          />
        </Button>
      </Form.Field>
    )
  }
}

FileItem.propTypes = {
  actionType: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  onAction: PropTypes.func.isRequired,
  accept: PropTypes.string.isRequired,
  width: PropTypes.number,
  tooltip: PropTypes.string
}

FileItem.defaultProps = {}



// WEBPACK FOOTER //
// ./webAdmin/forms/fileItem.js